import React, { useEffect } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { jwtDecode } from 'jwt-decode'
import { ConvexProvider } from 'convex/react'
import AppRouter from './Router'
import { convex } from './convex'

function App() {
	useEffect(() => {
		const setUserInCrisp = () => {
			try {
				const jwtToken = localStorage.getItem('jwtToken')

				if (jwtToken && window.$crisp) {
					const decodedToken = jwtDecode(jwtToken)
					const userEmail = decodedToken.email

					if (userEmail) {
						window.$crisp.push(['set', 'user:email', userEmail])
						window.$crisp.push([
							'set',
							'user:nickname',
							userEmail.split('@')[0],
						])
					}
				} else if (window.$crisp) {
					window.$crisp.push(['set', 'user:email', null])
					window.$crisp.push(['set', 'user:nickname', null])
				}
			} catch (error) {
				console.error('Error setting Crisp user data:', error)
			}
		}

		const setUserInClarity = () => {
			try {
				const jwtToken = localStorage.getItem('jwtToken')

				if (jwtToken && window.clarity) {
					const decodedToken = jwtDecode(jwtToken)
					const userEmail = decodedToken.email

					if (userEmail) {
						window.clarity('identify', userEmail, {
							email: userEmail,
							friendlyName: userEmail.split('@')[0],
						})
					}
				}
			} catch (error) {
				console.error('Error setting Clarity user data:', error)
			}
		}

		const setUserInGA = () => {
			try {
				const jwtToken = localStorage.getItem('jwtToken')

				if (jwtToken && window.gtag) {
					const decodedToken = jwtDecode(jwtToken)
					const userEmail = decodedToken.email

					if (userEmail) {
						window.gtag('set', 'user_properties', {
							user_id: userEmail,
							user_email: userEmail,
						})
					}
				}
			} catch (error) {
				console.error('Error setting GA user data:', error)
			}
		}

		setUserInCrisp()
		setUserInClarity()
		setUserInGA()

		const handleStorageChange = e => {
			if (e.key === 'jwtToken') {
				setUserInCrisp()
				setUserInClarity()
				setUserInGA()
			}
		}

		window.addEventListener('storage', handleStorageChange)

		return () => {
			window.removeEventListener('storage', handleStorageChange)
		}
	}, [])

	return (
		<ConvexProvider client={convex}>
			<Router>
				<AppRouter />
			</Router>
		</ConvexProvider>
	)
}

export default App
